import React from 'react';
import PropTypes from 'prop-types';

import { Text } from 'components/common/Elements/Elements';

import classes from './BarTooltip.module.scss';

const BarTooltip = ({ name, color, percent }) => {
  return (
    <Text type="p" className={classes.item}>
      <img
        alt=""
        className={classes.square}
        style={{ backgroundColor: color }}
      ></img>
      <Text className={classes.name}>{name}</Text>
      <Text className={classes.text}>
        {percent || percent === 0 ? `${percent}%` : 'NA'}
      </Text>
    </Text>
  );
};

BarTooltip.propTypes = {
  name: PropTypes.string,
  color: PropTypes.string,
  percent: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default BarTooltip;
